/**
 * @Author: v_jppjpeng
 * @Date: 2023-12-12 09:59:55
 * @Explain: 页面 - 加载中
 */
import classNames from 'classnames';
import { CSSProperties, ReactNode } from 'react';
import { Loading, LoadingProps } from 'tdesign-react';

export type PropsType = {
  className?: string;
  style?: CSSProperties;
  isShow?: boolean;
  fixed?: boolean;
  absolute?: boolean;
  center?: boolean;
  loadingText?: string | ReactNode;
  /**
   * 尺寸，示例：small/medium/large/12px/56px/0.3em
   * @default medium
   */
  size?: LoadingProps['size'];
};
export default function PageLoading(props: PropsType) {
  const {
    className,
    style,
    isShow = false,
    fixed,
    absolute,
    center,
    loadingText,
    size = 'medium',
  } = props;

  return isShow ? (
    <div
      className={classNames(
        { 'page-loading': true, fixed, absolute, center },
        className,
      )}
      style={style}
    >
      <Loading size={size} text={loadingText} />
    </div>
  ) : (
    <></>
  );
}
